import React from 'react';

export const generateAvatar = (name: string) => {
  const safeName = name && name.trim().length > 0 ? name.trim() : 'Seeker';
  const initials = safeName.split(' ').map(n => n[0]).join('');
  const colors = [
    'bg-blue-500', 'bg-green-500', 'bg-purple-500', 
    'bg-pink-500', 'bg-yellow-500', 'bg-indigo-500'
  ];
  const colorIndex = safeName.charCodeAt(0) % colors.length;
  
  return (
    <div className={`w-12 h-12 ${colors[colorIndex]} rounded-full flex items-center justify-center text-white font-semibold`}>
      {initials}
    </div>
  );
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(amount);
};
